import { ShieldCheck, ShieldAlert, KeyRound } from "lucide-react";

export default function IntegrationBanner({ status }) {
  if (!status) return null;
  const google = status.google;
  const configured = google?.configured;

  if (configured) {
    return (
      <div
        className="pp-surface px-5 py-3 flex flex-wrap items-center gap-3 text-sm"
        data-testid="integration-banner"
        data-configured="true"
      >
        <ShieldCheck className="h-4 w-4 text-[#6CC24A] shrink-0" />
        <div className="flex-1 min-w-0">
          <span className="text-white">
            Google integrations connected — Reviews, Google Business Profile
            and Technical Trust are verified from live signals.
          </span>
          <span className="text-[#C7CBD1] ml-2">
            PageSpeed + Places active.
          </span>
        </div>
      </div>
    );
  }

  // Unconfigured — full call-out card
  return (
    <div
      className="border border-[#EAB30855] bg-[#231D0F] p-5 flex flex-col md:flex-row md:items-center gap-4"
      data-testid="integration-banner"
      data-configured="false"
    >
      <div className="flex items-start gap-3 flex-1">
        <div className="p-2 border border-[#EAB30855] bg-[#EAB3081A] shrink-0">
          <ShieldAlert className="h-4 w-4 text-[#EAB308]" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="pp-label text-[#EAB308] mb-1">Model estimate</div>
          <div className="font-display text-white text-base leading-snug">
            This Trust Score is a modeled estimate — not a live measurement of
            your business yet.
          </div>
          <p className="text-xs text-[#C7CBD1] mt-2 leading-relaxed max-w-2xl">
            Scores, category values, and findings are generated by Pulse
            Point's deterministic model from the business name, website, and
            industry you entered. To switch to <span className="text-white">verified
            live signals</span> — real Google Business Profile data, real
            review counts, real Core Web Vitals — connect a Google API key.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <div className="pp-badge-neutral flex items-center gap-1.5">
          <KeyRound className="h-3 w-3" />
          <span className="metric text-[10px]">GOOGLE_MAPS_API_KEY</span>
        </div>
      </div>
    </div>
  );
}
